import { SavedFile } from '../../interfaces';

export const FileUploadCase = async (
  file: File,
  csrfToken: string,
  token: string,
  callback: (x: any) => void,
  loadingCallback: (x: any) => void,
  setError: (error: string) => void,
  gdpr: boolean
): Promise<any> => {
  try {
    const data = new FormData();
    data.append(file.name, file);

    data.set('recaptcha', token);
    data.set('csrfToken', csrfToken);
    if (gdpr) data.set('gdpr', 'true');
    const request = new XMLHttpRequest();
    request.open('post', '/api/file');

    request.upload.addEventListener('progress', async function (e) {
      const percent_completed = (e.loaded / e.total) * 100;

      loadingCallback({
        ...file,
        uploadPercent: percent_completed,
        size: e.total,
      });
    });

    request.addEventListener('load', async function (e) {
      const percent_completed = (e.loaded / e.total) * 100;
      const response = JSON.parse(request.response);
      if (response.savedFiles) {
        response.savedFiles = response.savedFiles.map((savedFile: SavedFile) => ({
          ...savedFile,
          uploadPercent: percent_completed,
          size: file.size,
        }));
      }
      if (response.rejectedFiles && response.rejectedFiles.length) {
        setError(
          'invalidFileFormat ' + response.rejectedFiles.map((item: any) => item.name).join(', ')
        );
      }

      callback(response);
    });
    request.send(data);
    return await request.response;
  } catch (error) {
    console.log(error);
    return null;
  }
};
